export const INVENTORY = 'INVENTORY';
export const ADD_INVENTORY_ITEMS_REQUEST = `${INVENTORY}/addInventoryItemsRequest`;
export const GET_INVENTORY_ITEMS_REQUEST = `${INVENTORY}/getInventoryItemsRequest`;
export const UPDATE_INVENTORY_ITEMS_REQUEST = `${INVENTORY}/updateInventoryItemsRequest`;
export const REMOVE_INVENTORY_ITEMS_REQUEST = `${INVENTORY}/removeInventoryItemRequest`;
export const FETCH_RECIPES_REQUEST = `${INVENTORY}/fetchRecipesRequest`;
export const FETCH_MATCHING_INVENTORIES_REQUEST = `${INVENTORY}/getInventoryOptionsRequest`;
export const MANAGE_RECIPE_REQUEST = `${INVENTORY}/manageRecipeRequest`;
export const REMOVE_RECIPE_REQUEST = `${INVENTORY}/removeRecipeRequest`;
